import { useEffect, useState } from "react";

import { translate, IsOnPrem } from "@utils";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

export const PolicyFormActionSelect = ({ viewOnly = false, activePolicy, setActivePolicy }) => {
	const [selection, setSelection] = useState(activePolicy.action);

	const handleSelection = (e) => {
		setSelection(e.target.value);
		setActivePolicy((prevState) => ({ ...prevState, action: e.target.value }));
	};

	return (
		<FormControl>
			<InputLabel id={`cvePolicyForm-action`}>{translate("action")}</InputLabel>
			<Select style={{ minWidth: "150px" }} labelId={`cvePolicyForm-action`} disabled={viewOnly} value={selection} label={translate("action")} onChange={handleSelection}>
				<MenuItem value={2}>{translate("allow")}</MenuItem>
				<MenuItem value={1}>{translate("block")}</MenuItem>
				<MenuItem value={3}>{translate("alert")}</MenuItem>
			</Select>
		</FormControl>
	);
};
